import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Menu, Modal} from 'antd';
import {useTranslation} from "react-i18next";
import {useModal} from "../../../core/context/ModalContext";
import ApiService from "../../../core/service/api-service";
import AutoExportRuleCreateEdit from "../AutoExportRuleCreateEdit";
import {useDataGrid} from '../../../core/components/data-grid/DataGridContext';
import {ExclamationCircleOutlined} from '@ant-design/icons';
import {PERMISSIONS, useUser} from "../../../core/context/UserContext";

const {confirm} = Modal;

export default function AutoExportRuleRowMenu({row}) {
    const {t} = useTranslation();
    const {openModal, closeModal} = useModal();
    const {refreshDataGrid} = useDataGrid();
    const {hasPermission} = useUser();
    
    const handleDelete = () => {
        confirm({
            title: t('Are you sure you want to delete this rule?'),
            icon: <ExclamationCircleOutlined />,
            content: t('This action cannot be undone.'),
            okText: t('Yes'),
            okType: 'danger',
            cancelText: t('No'),
            async onOk() {
                const response = await ApiService.AutoExport.DeleteRule(row.id);
                if(response.success) {
                    refreshDataGrid();
                }
            },
        });
    }
    
    return (
        <>
            <RowMenu text={row.id}>
                <Menu>
                    {hasPermission(PERMISSIONS.AUTO_EXPORT_MANAGE) && (
                        <Menu.Item key={'rule-edit'} onClick={() => {
                            openModal(t('Edit Auto Export Rule'), (
                                <>
                                    <AutoExportRuleCreateEdit
                                        ruleId={row.id}
                                        onSaved={() => {
                                            closeModal();
                                            refreshDataGrid();
                                        }}
                                    />
                                </>
                            ), null, 1200)
                        }}>
                            <div>
                                {t('Edit')}
                            </div>
                        </Menu.Item>
                    )}
                    {hasPermission(PERMISSIONS.AUTO_EXPORT_MANAGE) && (
                        <Menu.Item key={'rule-delete'} onClick={handleDelete}>
                            <div style={{color: 'red'}}>
                                {t('Delete')}
                            </div>
                        </Menu.Item>
                    )}
                </Menu>
            </RowMenu>
        </>
    )
}
